/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_TitleInputs */

const en_mk_how_title = /** @type {(inputs: Mk_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From sign-up to a finished task`)
};

const id_mk_how_title = /** @type {(inputs: Mk_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari daftar sampai tugas selesai`)
};

/**
* | output |
* | --- |
* | "From sign-up to a finished task" |
*
* @param {Mk_How_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_title = /** @type {((inputs?: Mk_How_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_title(inputs)
	return en_mk_how_title(inputs)
});